import React from 'react';

export const GlobalContext = React.createContext({
    Claims: [],
    Calificaciones: [],
    Horarios: [],
    darkTheme: false,
    toggleTheme: null,
   // userAgent: navigator.userAgent || navigator.vendor || window.opera,
    //isMobile: /windows phone|android|iPad|iPhone|iPod/i.test(navigator.userAgent) ? true : false,


});